import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from "../../utils/customPropTypes";
import bannerStyle from '../../../scss/components/GenericBanner/Banner';
import style1 from '../../../scss/components/Applications/ApplicationsSummary';
import ImageBlock from '../ImageBlock';
import ButtonLink from '../ButtonLink';
import SafeHTML from '../SafeHTML';
import { Transition } from 'semantic-ui-react'
import 'semantic-ui-css/components/transition.min.css';
export default class ApplicationSummary extends React.Component {
    static propTypes = {
        category: PropTypes.shape({
            name: PropTypes.string,
            description: PropTypes.string,
            subcategories: PropTypes.array,
            applications: PropTypes.array
        }),
        onViewDetail: PropTypes.func
    }
    constructor(props) {
        super(props);
        this.state = {
            currentCategory: null
        };
    }
    componentDidMount() {
        //load/populate category
        var hf_applicationsJson = document.querySelector('[name="hf_applicationsJson"]')
        let applicationsJson = hf_applicationsJson.value || '{}';
        var currCategory = JSON.parse(applicationsJson);
        console.log(currCategory);
        this.setState({ currentCategory: currCategory });
    }
    getApplicationsCardList = (applicationsList) => {
        var self = this;
        if (applicationsList && applicationsList.length > 0) {
            return applicationsList.map(function (objApp, index) {
                return (<div key={index} className="app-summary-item">
                    <div className="row">
                        <div className="col">
                            <div className="app-summary-object">
                                <ImageBlock image={objApp.image.url ? objApp.image : objApp.product.prodImage} addWrapper={false} imgClassName="object-embed center"></ImageBlock>
                            </div>
                        </div>
                        <div className="col">
                            <h5 className="app-summary-title">{objApp.product.category} 解决方案</h5>
                            <h2 className="app-summary-main-title">{objApp.product.name}</h2>
                            <div className="app-summary-desc"><SafeHTML>{objApp.summary}</SafeHTML></div>
                            {(objApp.solutionPdf.url || objApp.learnMore) && <div className="app-summary-action">
                                {objApp.solutionPdf.url && <ButtonLink text="Get Solution PDF" className="btn btn-outline" url={objApp.solutionPdf.url} openInNewWindow="True"></ButtonLink>}
                                {objApp.learnMore && <ButtonLink text="Request for Quote" className="btn btn-link btn-has-icon" icon="icon icon-direction-right" url={objApp.learnMore}></ButtonLink>}
                            </div>
                            }
                        </div>
                    </div>
                </div>);
            });
        }
        else
            return null;
    }
    getParentPageURL = () => {
        var parentPage = document.querySelector('body').getAttribute('parent-page');
        if (parentPage) {
            var [url, title] = parentPage.split(';');
            return url;
        }
        return null;
    }
    getGoToParentAnchor = (category, index) => {
        if (!category)
            return null;
        let anchorIcon, anchorText;
        if (category.slug) {
            anchorIcon = <i className="icon icon-prev"></i>
            anchorText = "全部 " + category.name;
        }
        else {
            anchorIcon = <i className="icon icon-prev"></i>
            anchorText = category.name;
        }

        var linkUrl = this.getParentPageURL();
        if (!category.slug)
            linkUrl = linkUrl + "#" + category.name;
        console.log(window.location);
        return <a key={index} className="btn btn-link-normal btn-back-link" href={linkUrl}>
            {anchorIcon}&nbsp;{anchorText}
        </a>
    }
    getGoToParentCategoryLinks = () => {
        var category = this.state.currentCategory;
        if (!category)
            return null;
        let anchors = [];
        var index = 0;
        if (category.parentCategory && category.parentCategory.name) {
            anchors.push(this.getGoToParentAnchor(category.parentCategory, index));
        }
    // while (category.parentCategory && category.parentCategory.name) {
    //     anchors.push(this.getGoToParentAnchor(category.parentCategory, index));
    //     category = category.parentCategory;
    //     index++;
    // }
        return <div className="has-back-link">
            <div className="container">{anchors.reverse()}</div>
        </div>
    }
    render() {
        if (this.state.currentCategory == null)
            return null;
        let currCategory = this.state.currentCategory;
        return (
            <>
                <section className="application-category-summary banner banner-center banner-hero">
                    {this.getGoToParentCategoryLinks()}
                    <div className="container banner-wrapper">
                        <div>
                            {currCategory.name && <h1 className="banner-main-title">{currCategory.name}</h1>}

                            {currCategory.description && <div className="banner-desc">
                                <SafeHTML>
                                    {currCategory.description}
                                </SafeHTML>
                            </div>}
                        </div>
                    </div>
                </section>
                
                <section className="app-summary-section">
                    <div className="container">
                        <h2 className="app-summary-result-title">测色应用探索： "{currCategory.name}."</h2>
                        <div className="app-summary">
                            {this.getApplicationsCardList(currCategory.applications)}
                        </div>
                    </div>
                </section>

            </>
        )
    }
}
